module.exports = __webpack_public_path__ + "img/pengcheng.b7966ebe.png";